<template>
  <div class="app-layout orver-hidden-x">
    <!-- <el-row
      type="flex"
      class="
        margin-bottom-20
        margin-top-10
        flex-justify-between
        flex-align-center"
    >
      <el-col :span="24" align="right">
        <b class="padding-right-20">当前时间：{{ analyzeTime }}</b>
        <el-date-picker
          v-model="range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          unlink-panels
          :clearable="false"
          format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>
    </el-row> -->
    <el-row type="flex" class="
        margin-bottom-20
        margin-top-10
        flex-justify-between
        flex-align-center">
      <el-col :span="24" align="left">
        <!-- <b class="padding-right-20">当前时间：{{ analyzeTime }}</b> -->
        <el-date-picker v-model="pickerDate" type="date" align="center" size="small" unlink-panels
          :clearable="false" format="yyyy-MM-dd" :picker-options="pickerOptions"
          :placeholder="analyzeTime"></el-date-picker>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <b class="font-size-18">流量数据</b>
            <!-- <i class="el-icon-s-data"></i>
            <b class="font-size-18">30天变化趋势 <small> (点击切换其他日期)</small></b>
          </div>
          <div id="barChart" class="chart-box user-chart-box"> -->
          </div>
          <AnalyzeData :analyzeData="analyzeData" v-loading="apiDataLoading"/>
        </el-card>
      </el-col>
    </el-row>
    <AnalyzeTendency isMountedRender :xBarArray="xBarArray" :yBarArray="yBarArray"
      :analyzeTime="analyzeTime" @handleSwitch="handleSwitch"
      :recentTdendencyLoading="recentTdendencyLoading">
    </AnalyzeTendency>
    <div>
      <el-row type="flex" :gutter="20">
      <el-col :span="12" class="margin-top-20">
        <el-card align="left" class="box-card" shadow="never">
          <div>
            <!-- <i class="el-icon-hot-water"></i>  -->
            <b class="font-size-18">接口请求耗时分布</b>
          </div>
          <div class="box-res" style="height: 290px" v-loading="apiCostLoading">
            <InterfaceTime v-if="showNewChart" isMountedRender :xDataArray="xDataArray"
              :yDataArray="yDataArray"></InterfaceTime>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="margin-top-20">
        <el-card align="left" class="box-card" shadow="never">
          <div>
            <!-- <i class="el-icon-hot-water"></i> -->
            <b class="font-size-18">接口请求平均耗时Top 50</b>
          </div>
          <div class="box-res" style="height: 280px" v-loading="apiAvgCostLoading">
            <el-table class="margin-top-20" height="260px" :data="apiAvgCostTopData" stripe
              style="width: 100%">
              <el-table-column prop="uri" label="接口地址" min-width="300">
                <template slot-scope="{ row }">
                  <span class="uri-link" @click="handleUriRedirect(row)">{{ row.uri }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="count" align="center" label="数量" min-width="80">
              </el-table-column>
              <el-table-column prop="costAvg" align="center" label="平均耗时(ms)" min-width="100">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    </div>
    <div>
      <el-row type="flex" :gutter="20">
        <el-col :span="12" class="margin-top-20">
          <el-card align="left" class="box-card" shadow="never">
            <div>
              <!-- <i class="el-icon-hot-water"></i>  -->
              <b class="font-size-18">接口请求量Top 50</b>
            </div>
            <div class="box-res" style="height: 280px"  v-loading="apiStatLoading">
              <el-table class="margin-top-20" height="260px" :data="apiRequestCountTopData" stripe
                style="width: 100%">
                <el-table-column prop="uri" label="接口地址" min-width="300">
                  <template slot-scope="{ row }">
                    <span class="uri-link" @click="handleUriRedirect(row)">{{ row.uri }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="count" align="center" label="数量" min-width="80">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>

        <el-col :span="12" class="margin-top-20">
          <el-card align="left" class="box-card" shadow="never">
            <div>
              <!-- <i class="el-icon-hot-water"></i> -->
              <b class="font-size-18">接口错误数Top 50</b>
            </div>
            <div class="box-res" style="height: 280px" v-loading="apiErrorLoading">
              <el-table class="margin-top-20" height="260px" :data="apiErrorCountTopData" stripe
                style="width: 100%">
                <el-table-column prop="uri" label="接口地址" min-width="300">
                  <template slot-scope="{ row }">
                    <span class="uri-link" @click="handleUriRedirect(row)">{{ row.uri }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="count" align="center" label="数量" min-width="80">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <!-- <el-col :span="24" class="margin-top-20">
          <el-card align="left" class="box-card" shadow="never">
            <div>
              <i class="el-icon-hot-water"></i> <b class="font-size-18">接口请求平均耗时Top 50</b>
            </div>
            <div class="box-res" style="height: 280px">
              <el-table
                class="margin-top-20"
                height="260px"
                :data="apiAvgCostTopData"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="uri" label="接口地址" min-width="300">
                  <template slot-scope="{ row }">
                    <span class="uri-link" @click="handleUriRedirect(row)">{{ row.uri }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="count" align="center" label="数量" min-width="80">
                </el-table-column>
                <el-table-column prop="costAvg" align="center" label="平均耗时(ms)" min-width="100">
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import { mapGetters } from 'vuex';
import {
  queryApiCount,
  queryApiStat,
  queryApiRequestCountTop,
  queryApiErrorCountTop,
  queryApiAvgCostTop,
  // queryApiTendency,
  queryApiCost,
} from '@/api/tracking';
import { getMiddleData } from '@/utils/index';
// import AnalyzeHealthy from './components/healthy.vue';
import AnalyzeData from './components/data.vue';
import AnalyzeTendency from './components/tendency-chart.vue';
import InterfaceTime from '../api-situation/components/interface-time.vue';

export default {
  name: 'TrackingSlowSystemCall',
  data() {
    return {
      // 默认选定当天
      pickerDate: new Moment().format('YYYY-MM-DD'),
      xDataArray: [],
      yDataArray: [],
      // 流量数据
      analyzeData: [
        { title: '当前服务名', data: '全部服务', tip: '当前服务名' },
        {
          title: '接口请求数',
          data: 0,
          key: 'apiRequest',
          tip: '发起请求总数量',
        },
        {
          key: 'apiError',
          title: '接口错误数',
          data: 0,
          tip: '发起请求失败总数量',
        },
        {
          key: 'apiErrorScale',
          title: '接口异常率',
          data: 0,
          tip: '（接口错误数 / 接口请求数） * 100%',
        },
        {
          key: 'costAvg',
          title: '平均耗时',
          data: 0,
          tip: '从接收请求到完成响应的平均耗时',
        },
      ],
      yBarArray: [],
      xBarArray: [],
      showNewChart: true,
      range: [],
      apiRequestCountTopData: [],
      apiErrorCountTopData: [],
      apiAvgCostTopData: [],
      recentTdendencyLoading: false,
      apiAvgCostLoading: false,
      apiDataLoading: false,
      apiCostLoading: false,
      apiErrorLoading: false,
      apiStatLoading: false,
      loading: false,
      pieChartTopData: [],
      tableCostTopData: [],
      activeTabName: 'first',
      activeName: 'first',
      // barChart: null,
      // barChartChange: null,
      // barChartNumber: null,
      // pieChart: null,
      analyzeTimeFrom: new Moment().subtract(29, 'days').format('YYYY-MM-DD'),
      analyzeTimeTo: new Moment().format('YYYY-MM-DD'),
      analyzeTime: new Moment().format('YYYY-MM-DD'),
      pickerMinDate: null,
      pickerMaxDate: null,
      day29: 29 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (date) => {
          const time = date.getTime();
          return time > new Date() * 1;
        },
      },
    };
  },
  components: {
    // AnalyzeHealthy,
    AnalyzeData,
    AnalyzeTendency,
    InterfaceTime,
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    // 获取今天的时间
    const today = new Moment().format('YYYY-MM-DD');
    this.range = [
      new Moment().subtract(29, 'days').format('YYYY-MM-DD'),
      today,
    ];

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  created() {
    this.search();
  },
  computed: {
    ...mapGetters('app', ['source', 'env', 'serverName', 'bizChannel']),
  },
  watch: {
    pickerDate: {
      handler(val) {
        this.analyzeTimeFrom = new Moment(val)
          .subtract(29, 'days')
          .format('YYYY-MM-DD');
        this.analyzeTimeTo = new Moment(val).format('YYYY-MM-DD');
        this.analyzeTime = new Moment(val).format('YYYY-MM-DD');
        this.search();
      },
    },
    range: {
      handler(val) {
        this.analyzeTimeFrom = new Moment(val[0]).format('YYYY-MM-DD');
        this.analyzeTimeTo = new Moment(val[1]).format('YYYY-MM-DD');
        this.search();
      },
      deep: true,
    },
    source: {
      handler() {
        this.search();
      },
    },
    serverName: {
      handler() {
        this.search();
      },
    },
    env() {
      this.search();
    },
    bizChannel() {
      this.search();
    },
  },
  methods: {
    // 接口请求耗时分布
    async queryApiCost(date) {
      this.showNewChart = false;
      this.apiCostLoading = true;
      const yArray = [];

      const {
        analyzeTimeTo,
      } = this;
      const { data } = await queryApiCost({
        analyzeTimeFrom: date
          ? `${date} 00:00:00`
          : `${analyzeTimeTo} 00:00:00`,
        analyzeTimeTo: date ? `${date} 23:59:59` : `${analyzeTimeTo} 23:59:59`,
      });

      if (data) {
        // eslint-disable-next-line no-restricted-syntax
        for (const pars in data) {
          if (pars) {
            yArray.push(data[pars]);
          }
        }
        this.yDataArray = yArray;
        this.xDataArray = ['<1秒', '1-5秒', '5-10秒', '10-30秒', '>30秒'];
      }
      this.apiCostLoading = false;
      this.showNewChart = true;
    },
    // 控制点击趋势图切换日期
    handleSwitch(date) {
      this.pickerDate = date;
    },
    // 请求流量数据
    async searchQueryFlowData(params) {
      this.apiDataLoading = true;

      const { data } = await queryApiStat(params);
      this.apiDataLoading = false;

      this.analyzeData.forEach((item) => {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(item.key)) {
          // eslint-disable-next-line no-param-reassign
          item.data = data[item.key] || 0;
          if (item.key === 'apiErrorScale') {
            // eslint-disable-next-line no-param-reassign
            item.data = `${(data[item.key] * 100).toFixed(2)} %`;
          }
        } else if (!item.key) {
          // eslint-disable-next-line no-param-reassign
          item.data = this.serverName ? this.serverName : '全部服务';
        }
      });
    },
    handleUriRedirect({ uri }) {
      this.$router.push({
        name: 'AnalyzeInterfaceList',
        query: {
          time: this.analyzeTime,
          uri,
        },
      });
    },
    async queryApiRequestCountTop(params) {
      this.apiStatLoading = true;
      const { data } = await queryApiRequestCountTop(params);
      this.apiRequestCountTopData.splice(0);
      this.apiRequestCountTopData.push(...(data || []));
      this.apiStatLoading = false;
    },
    async queryApiErrorCountTop(params) {
      this.apiErrorLoading = true;
      const { data } = await queryApiErrorCountTop(params);
      this.apiErrorCountTopData.splice(0);
      this.apiErrorCountTopData.push(...(data || []));
      this.apiErrorLoading = false;
    },
    async queryApiAvgCostTop(params) {
      this.apiAvgCostLoading = true;
      const { data } = await queryApiAvgCostTop(params);
      this.apiAvgCostTopData.splice(0);
      this.apiAvgCostTopData.push(...(data || []));
      this.apiAvgCostLoading = false;
    },
    async search() {
      // this.loading = true;
      try {
        const {
          analyzeTimeTo,
          analyzeTimeFrom,
        } = this;
        const yArray = [];
        // const xArray = [];
        const params = {
          requestTimeFrom: `${analyzeTimeTo} 00:00:00`,
          requestTimeTo: `${analyzeTimeTo} 23:59:59`,
        };

        this.queryApiCost();
        this.searchQueryFlowData(params);
        this.queryApiRequestCountTop(params);
        this.queryApiErrorCountTop(params);
        this.queryApiAvgCostTop(params);

        this.recentTdendencyLoading = true;

        const {
          data: { apiCounts },
        } = await queryApiCount({
          analyzeTimeFrom,
          analyzeTimeTo,
        });

        this.recentTdendencyLoading = false;

        const middle = getMiddleData(
          'day',
          this.analyzeTimeFrom,
          this.analyzeTimeTo,
          // eslint-disable-next-line comma-dangle
          'MM-dd'
        );

        middle.forEach((task) => {
          // eslint-disable-next-line no-return-assign, no-param-reassign
          const arr = apiCounts.find(
            // eslint-disable-next-line comma-dangle
            (item) => item.analyzeDate.slice(5) === task
          );
          if (arr) {
            yArray.push(arr.currentCount);
          } else {
            yArray.push(0);
          }
        });
        if (yArray.length > 0) {
          // 防止无数据时传空数组
          // while (true) {
          // 数据长度不够往前补0
          //   if (yArray.length < middle.length) {
          //     yArray.unshift(0);
          //   } else {
          //     break;
          //   }
          // }
          this.yBarArray = yArray;
          this.xBarArray = middle;
        } else {
          // 切换服务名无数据时初始化
          this.yBarArray = [0];
          this.xBarArray = middle;
        }

        // if (apiCounts.length) {
        //   this.analyzeTime = apiCounts.slice(-1)[0].analyzeDate;
        // }

        // const option = {
        //   tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //       // 坐标轴指示器，坐标轴触发有效
        //       type: 'line', // 默认为直线，可选为：'line' | 'shadow'
        //     },
        //   },
        //   grid: {
        //     height: '160',
        //     left: '2%',
        //     right: '2%',
        //     bottom: '0%',
        //     containLabel: true,
        //   },
        //   color: ['#5d5cb6'],
        //   xAxis: [
        //     {
        //       type: 'category',
        //       data: xArray,
        //       // 设置轴线的属性
        //       axisLine: {
        //         lineStyle: {
        //           type: 'dashed',
        //           color: '#838383',
        //           // width: 8
        //         },
        //       },
        //       axisLabel: {
        //         interval: 0,
        //         rotate: 30,
        //         textStyle: {
        //           color: '#838383', // 坐标值得具体的颜色
        //         },
        //       },
        //     },
        //   ],
        //   yAxis: [
        //     {
        //       name: '次数',
        //       type: 'value',
        //       // 网格
        //       splitLine: {
        //         show: false,
        //       },
        //       // 设置轴线的属性
        //       axisLine: {
        //         lineStyle: {
        //           type: 'dashed',
        //           color: '#838383',
        //           // width: 8
        //         },
        //       },
        //       // 数值
        //       axisLabel: {
        //         textStyle: {
        //           color: '#838383', // 坐标值得具体的颜色
        //         },
        //       },
        //     },
        //   ],
        //   series: [
        //     {
        //       name: '发生次数',
        //       barWidth: 25, // 柱图宽度
        //       type: 'bar',
        //       emphasis: {
        //         focus: 'series',
        //       },
        //       data: yArray,
        //     },
        //   ],
        // };

        // this.barChart.setOption(option);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    handleResize() {
      // eslint-disable-next-line no-unused-expressions
      this.activeName === 'first'
        ? this.barChart && this.barChart.resize()
        : this.barChart1 && this.barChart1.resize();
    },
  },
};
</script>
<style lang="scss" scoped>
.color-green {
  color: #00af56;
}

.color-red {
  color: #f85149;
}

.color-gray {
  color: #a3a5b0;
}

.user-chart-box {
  height: 200px;
}

.small-chart-box {
  height: 220px;
}

.uri-link {
  cursor: pointer;
  color: rgb(64, 158, 255);

  &:hover {
    text-decoration: underline;
  }
}

.radius-rad {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e67482;
}

.txt-bule {
  color: #1890ff;
}

.txt-gray {
  color: #666;
}

.app-layout {
  min-width: 928px;
  padding: 20px;
  min-height: calc(100vh);
}

.table-wrap {
  position: relative;
}

.table-wrap-date {
  position: absolute;
  right: 0;
  top: 10px;
  color: #5d5cb6;
  font-weight: bold;
}

.table-row {
  color: #303133;
  cursor: pointer;
}

.box-res {
  font-weight: bold;
  font-size: 30px;
}

.app-layout {
  &::v-deep {
    .el-table thead th {
      background: #fff;
    }
    .el-table td,
    .el-table th.is-leaf {
      border: 0;
    }
  }
}
</style>
